export default function contenteditable($sce) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, element, attrs, ngModel) {
      var read = function() {
        var html = element[0]['innerText'];
        return ngModel.$setViewValue(html);
      };
      if (!ngModel) {
        return;
      }
      ngModel.$render = function() {
        element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
      };
      element.on('blur change', function() {
        scope.$evalAsync(read);
      });
    }
  };
}

contenteditable.$inject = ['$sce'];
